import React from "react";
import { Image, Text, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { TouchableOpacity } from "react-native";
import { AppImages } from "../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const GoLiveScene = () => {
  const deviceSize = useDeviceSize();

  return (
    <View>
      <Text style={[AppFontStyle.REGULAR_ANYBODY_16, { marginVertical: 5 }]}>
        Scene
      </Text>
      <View
        style={{
          flexDirection: "row",
          backgroundColor: AppColors.grayColor_505050,
          padding: 10,
          columnGap: 10,
        }}
      >
        <Text
          style={[
            deviceSize === DEVICE_SIZES.XS
              ? AppFontStyle.REGULAR_ANYBODY_12
              : AppFontStyle.REGULAR_ANYBODY_16,
            { color: AppColors.gray_C3C3C3, flex: 1 },
          ]}
        >
          LandScape Mode
        </Text>
        <TouchableOpacity>
          <Image
            source={AppImages.arrowDown}
            style={{ height: 12, width: 15 }}
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default GoLiveScene;
